import { z } from 'zod';

/** Bump on any breaking contract change; all agents are notified (brief §15). */
export const API_VERSION = '1' as const;

const SEMVER = /^(\d+)\.(\d+)\.(\d+)$/;

export const semverSchema = z.string().regex(SEMVER, 'Expected a version like 1.2.3');

/** Compares two x.y.z versions. Returns -1, 0 or 1. */
export function compareVersions(a: string, b: string): -1 | 0 | 1 {
  const pa = parseSemver(a);
  const pb = parseSemver(b);
  for (let i = 0; i < 3; i += 1) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff > 0 ? 1 : -1;
  }
  return 0;
}

/** True when the running app is older than the server's minimum. */
export function isUpdateRequired(appVersion: string, minAppVersion: string): boolean {
  return compareVersions(appVersion, minAppVersion) < 0;
}

function parseSemver(version: string): [number, number, number] {
  const match = SEMVER.exec(version);
  if (!match) throw new Error(`Invalid version: ${version}`);
  return [Number(match[1]), Number(match[2]), Number(match[3])];
}
